//
export const GET_TRANSLATIONS_REQUEST = 'GET_TRANSLATIONS_REQUEST';
export const GET_TRANSLATIONS_SUCCESS = 'GET_TRANSLATIONS_SUCCESS';
export const GET_TRANSLATIONS_ERROR = 'GET_TRANSLATIONS_ERROR';

export const SET_TRANSLATION_LOCALE = 'SET_TRANSLATION_LOCALE';
